import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const Description = ({description}) => (
    <div className="sharing-description">
        {description.map((item, index) => (
            <p key={index}>{item}</p>))}
    </div>
);

Description.propTypes = {
    description: PropTypes.array.isRequired
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description/index.js